import React, { useState, useRef } from 'react';
import { CalculatorInstance } from './CalculatorInstance';
import { CalculationResult } from '../../types';
import { FileText, TrendingUp } from 'lucide-react';

export interface CalculatorState {
  calculators: number[];
  results: CalculationResult[];
  showTrend: boolean;
}

interface CalculatorManagerProps {
  onShowTrend: () => void;
  state: CalculatorState;
  onChange: (state: CalculatorState) => void;
  lastCalculatedResult?: CalculationResult;
}

export function CalculatorManager({ onShowTrend, state, onChange, lastCalculatedResult }: CalculatorManagerProps) {
  const resultsRefs = useRef<(HTMLDivElement | null)[]>([]);

  const handleAddCalculator = () => {
    const newIndex = state.calculators.length;
    onChange({
      ...state,
      calculators: [...state.calculators, newIndex]
    });
    
    // Scroll to new calculator after render
    setTimeout(() => {
      resultsRefs.current[newIndex]?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 100);
  };

  const handleDeleteCalculator = (index: number) => {
    const newResults = state.results.filter((_, i) => i !== index);
    onChange({
      ...state,
      calculators: state.calculators.filter((_, i) => i !== index),
      results: newResults
    });
  };

  const handleCalculate = (result: CalculationResult, index: number) => {
    const newResults = [...state.results];
    newResults[index] = result;
    onChange({
      ...state,
      results: newResults
    });
  };

  return (
    <div className="space-y-6">
      {state.calculators.map((_, index) => (
        <CalculatorInstance
          key={index}
          index={index}
          onDelete={index > 0 ? () => handleDeleteCalculator(index) : undefined}
          onCalculate={(result) => handleCalculate(result, index)}
          resultsRef={{ current: resultsRefs.current[index] }}
          previousValues={lastCalculatedResult}
        />
      ))}

      {state.results.length > 0 && (
        <div className="flex justify-center gap-4">
          <button
            onClick={handleAddCalculator}
            className="btn-primary flex items-center gap-2"
          >
            <FileText size={20} />
            Add Role Calculation
          </button>
          <button
            onClick={onShowTrend}
            className="btn-primary flex items-center gap-2"
          >
            <TrendingUp size={20} />
            Show Trend
          </button>
        </div>
      )}
    </div>
  );
}